import type { ImgHTMLAttributes } from 'react';
import { getImageLoadingProps, getImageUrl } from '@/lib/image';

type OptimizedImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'sizes'> & {
  src: string | null | undefined;
  sizes?: string;
  eager?: boolean;
};

export function OptimizedImage({ src, sizes, eager = false, ...props }: OptimizedImageProps) {
  const imageProps = getImageLoadingProps(src, sizes);

  return (
    <img
      {...props}
      {...imageProps}
      src={getImageUrl(src)}
      loading={eager ? 'eager' : imageProps.loading}
      fetchPriority={eager ? 'high' : props.fetchPriority}
    />
  );
}
